module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av764-7ca603976942bec3a639237016ce52f9.jpg";